module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e772f2b4f625f406e8bf913328d5c525.png";